import { FilterDefinitionModel } from 'src/core/model/data-grid.model';
import { useTranslation } from 'react-i18next';
import { CpoResponseModel } from 'src/core/model/cpo.model';
import { useTextFilter } from 'src/feature/data-grid/filter/generic-filter/use-text-filter';

export function useCpoFilter(): FilterDefinitionModel[] {
  const { t } = useTranslation();

  const cpoTranslations: Record<keyof CpoResponseModel, string> = t(
    'model.cpo',
    {
      returnObjects: true,
    },
  );

  const uidFilter = useTextFilter('uid', cpoTranslations.id);
  const publicKeyFilter = useTextFilter('publicKey', cpoTranslations.publicKey);
  const didFilter = useTextFilter('did', cpoTranslations.did);
  const endpointFilter = useTextFilter('endpoint', cpoTranslations.endpoint);

  return [uidFilter, publicKeyFilter, didFilter, endpointFilter];
}
